module.exports = __webpack_public_path__ + "img/deo_no_o.38dbaccd.png";